import _ from 'lodash'
import { getRoom } from '../selectors/objectSelectors'
import {
  getRoomConfigurationDisplayName,
  isChildAllowed,
  isNewStudioType,
  isYoungAdultAllowed,
  roomConfig
} from '../../logic/roomLogic'
import { isChild, shouldCollectGuestInformation } from '../../logic/guestLogic'
import { roomSelectionFormSelector } from './roomSelectionFormModule'
import { getValues } from 'redux-form'
import { guestRequirementsSelector } from './searchParamsModule'

const guestDetailsFormSelector = state => state.form.roomSelection.guestDetails

const guestDetailsFieldSelector = (state, guestIndex) => {
  const form = guestDetailsFormSelector(state)
  return form && form.length ? form[guestIndex] : {}
}

const roomIdSelector = (state, guestIndex) => {
  const guestDetails = guestDetailsFieldSelector(state, guestIndex)
  return guestDetails && guestDetails.room ? guestDetails.room.value : null
}

const guestTypeSelector = (state, guestIndex) => {
  const guestDetails = guestDetailsFieldSelector(state, guestIndex)
  return _.get(guestDetails, 'guestType.value', null)
}

export const guestTypeOptionsSelector = (state, guestIndex) => {
  const getDefaultGuestTypeOptions = minAdultAge => [
    { label: `${minAdultAge}+`, value: 'adult' }
  ]

  const {
    minAge,
    minAdultAge,
    childrenAllowed: childrenAllowedForProgram
  } = guestRequirementsSelector(state)

  let guestTypeOptions = getDefaultGuestTypeOptions(minAdultAge)

  const roomId = roomIdSelector(state, guestIndex)
  if (!roomId) {
    return guestTypeOptions
  }

  const { type } = getRoom(state, roomId)
  const roomMinAge = roomConfig[type].minAge
  if (roomMinAge > minAdultAge) {
    guestTypeOptions = getDefaultGuestTypeOptions(roomMinAge)
  }

  // At least one guest must be an adult
  if (guestIndex > 0 && childrenAllowedForProgram) {
    if (isYoungAdultAllowed(type)) {
      guestTypeOptions.push({
        label: `${minAge}-13`,
        value: 'youngAdult'
      })
    }
    if (isChildAllowed(type)) {
      guestTypeOptions.push({ label: '6 and below', value: 'child' })
    }
  }

  return guestTypeOptions
}

export const shouldCollectGuestInformationSelector = (state, guestIndex) => {
  const type = guestTypeSelector(state, guestIndex)
  return shouldCollectGuestInformation(type)
}

const getGuestTypesAssignedToRoom = (guestDetails, roomId) => {
  return _.reduce(
    guestDetails,
    (guestCounts, guestDetail) => {
      if (guestDetail.room !== roomId) {
        return guestCounts
      }

      const key = isChild(guestDetail.guestType) ? 'numChildren' : 'numGuests'
      guestCounts[key] += 1
      return guestCounts
    },
    { numGuests: 0, numChildren: 0 }
  )
}

export const validateNumAdultsChildren = ({ guestDetails }) => (
  dispatch,
  getState
) => {
  const state = getState()
  const roomSelectionForm = roomSelectionFormSelector(state)
  const roomSelectionValues = getValues(roomSelectionForm)
  const selectedRooms = _.flatMap(roomSelectionValues.listings, 'rooms')

  const errors = _.reduce(
    selectedRooms,
    (errors, room) => {
      const roomId = room.roomId
      const roomObject = getRoom(state, roomId)
      if (!isNewStudioType(roomObject.type)) return errors

      const guestTypes = getGuestTypesAssignedToRoom(guestDetails, roomId)
      const isValid =
        guestTypes.numGuests === room.numGuests &&
        guestTypes.numChildren === room.numChildren

      if (!isValid) {
        errors.push(
          "The number of adults and children doesn't match " +
            'the number selected on the previous page for ' +
            getRoomConfigurationDisplayName(room.roomConfiguration)
        )
      }

      return errors
    },
    []
  )

  return new Promise((resolve, reject) =>
    errors.length > 0 ? reject({ _error: errors }) : resolve({})
  )
}



// WEBPACK FOOTER //
// ./src/redux/modules/guestEntryFormModule.js